import { ReactNode } from "react"

// Renders a trailing "*" (required-field marker) in red, per design.
export function withRequiredAsterisk(label: string): ReactNode {
    const base = label.replace(/\s*\*\s*$/, "")
    if (base === label) {
        return label
    }
    return (
        <>
            {base} <span className="text-red-600">*</span>
        </>
    )
}
